/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_PassInputs */

const en_fw_tpl_pass = /** @type {(inputs: Fw_Tpl_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pass rate`)
};

const id_fw_tpl_pass = /** @type {(inputs: Fw_Tpl_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pass rate`)
};

/**
* | output |
* | --- |
* | "pass rate" |
*
* @param {Fw_Tpl_PassInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_pass = /** @type {((inputs?: Fw_Tpl_PassInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_PassInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_pass(inputs)
	return en_fw_tpl_pass(inputs)
});